module.exports = __webpack_public_path__ + "img/bmewm.d14304eb.jpg";